import { useState } from 'react'
import { Sparkles } from 'lucide-react'

import TableButton from 'components/Buttons/TableButtons/TableButton'
import { useListCampaignColumns } from 'services/campaignColumns'
import { blurActiveElement } from 'utils/focus'

import { AddAgentColumnModal } from './AddAgentColumnModal'

const MAX_COLUMNS_PER_CAMPAIGN = 5 // mirrors server/campaign_columns/constants.py

interface Props {
  campaignId: number
  campaignProductId?: number | null
  disabled?: boolean
}

export function AddAIColumnButton({
  campaignId,
  campaignProductId = null,
  disabled,
}: Props) {
  const [open, setOpen] = useState(false)
  const columnsQuery = useListCampaignColumns(campaignId)
  const count = columnsQuery.data?.results.length ?? 0
  const atLimit = count >= MAX_COLUMNS_PER_CAMPAIGN
  const isDisabled = disabled || atLimit

  return (
    <>
      <TableButton
        type="button"
        text={
          atLimit
            ? `Add Column (${count}/${MAX_COLUMNS_PER_CAMPAIGN})`
            : 'Add Column'
        }
        icon={Sparkles}
        iconSize={18}
        onClick={() => {
          blurActiveElement()
          setOpen(true)
        }}
        disabled={isDisabled}
        title={
          atLimit
            ? `Limit reached (${count}/${MAX_COLUMNS_PER_CAMPAIGN}). Delete a column to add another.`
            : undefined
        }
      />
      {open && (
        <AddAgentColumnModal
          campaignId={campaignId}
          campaignProductId={campaignProductId}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
